import { useMutation } from "@apollo/client";
import {
  DownloadAllCarrierLabelsDocument,
  MarkAllCarrierShippingAsShippedDocument,
} from "../../gql/generated/graphql";

export const useShipping = () => {
  const [downloadAllCarrierLabels] = useMutation(
    DownloadAllCarrierLabelsDocument
  );

  const [markAllCarrierShippingAsShipped] = useMutation(
    MarkAllCarrierShippingAsShippedDocument
  );

  return {
    downloadAllCarrierLabels: downloadAllCarrierLabels,
    markAllCarrierShippingAsShipped: markAllCarrierShippingAsShipped,
  };
};
